'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _autolinker = require('autolinker');

var _autolinker2 = _interopRequireDefault(_autolinker);

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatMessageText = function (_Component) {
  _inherits(ChatMessageText, _Component);

  function ChatMessageText() {
    _classCallCheck(this, ChatMessageText);

    return _possibleConstructorReturn(this, (ChatMessageText.__proto__ || Object.getPrototypeOf(ChatMessageText)).apply(this, arguments));
  }

  _createClass(ChatMessageText, [{
    key: 'render',
    value: function render() {
      var richTextContent = (0, _commonMessageFormatGetters.getRichText)(this.props.message);
      var parsedContent = (0, _commonMessageFormatGetters.getPlainText)(this.props.message);

      if (richTextContent && richTextContent.length) {
        parsedContent = this.props.useAutoLinker ? _autolinker2.default.link(richTextContent) : richTextContent;
      }

      return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: parsedContent } });
    }
  }]);

  return ChatMessageText;
}(_react.Component);

ChatMessageText.defaultProps = {
  useAutoLinker: true
};

ChatMessageText.propTypes = {
  message: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('CommonMessage'), (0, _RecordPropType2.default)('PubNubMessageRecord')]).isRequired,
  useAutoLinker: _react.PropTypes.bool
};

exports.default = ChatMessageText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/ChatMessageText.js
// module id = 307
// module chunks = 2 3